import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LocationTypePipe } from '../pipes/location-type.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MerchantStoreItem } from '../types/merchant-store-item.type';

@Component({
  selector: 'viewed-store-panel',
  standalone: true,
  imports: [MatIconModule, LocationTypePipe, MatButtonModule],
  templateUrl: './viewed-store-panel.component.html',
  styleUrl: './viewed-store-panel.component.scss',
})
export class ViewedStorePanelComponent {
  @Input() cardOnViewing!: MerchantStoreItem;

  @Output() closeCardViewing = new EventEmitter<void>();
  @Output() editStore = new EventEmitter<MerchantStoreItem>();

  getAddress() {
    if (typeof (this.cardOnViewing.Address) === 'string') {
      return this.cardOnViewing.Address;
    } else {
      return (this.cardOnViewing.Address as any).description;
    }
  }
}
